import { ButtonSize } from 'src/components/primitives/Button/types';
import { cj } from 'src/utils/classNames';

export const STANDARD_BUTTON_HORIZONTAL_PADDING_CLASSNAME: Record<
	ButtonSize,
	string
> = {
	sm: 'px-md',
	md: 'px-lg',
	lg: 'px-lg',
	xl: 'px-lg',
};

export const STANDARD_BUTTON_VERTICAL_PADDING_CLASSNAME: Record<
	ButtonSize,
	string
> = {
	sm: 'py-xs',
	md: 'py-sm',
	lg: 'py-md',
	xl: 'py-lg',
};

export const STANDARD_BUTTON_TEXT_SIZE_CLASSNAME: Record<ButtonSize, string> = {
	sm: 'typo-t4',
	md: 'typo-t3',
	lg: 'typo-t3',
	xl: 'typo-t2',
};

export const STANDARD_BUTTON_DISABLED_CLASSNAME = cj(
	'disabled:bg-button-disabled disabled:text-text-disabled',
	// For when a link is used for the button and we need to apply disabled styles to it.
	'data-disabled:cursor-not-allowed data-disabled:bg-button-disabled data-disabled:text-text-disabled'
);
